import { Cancel, Check, Pending } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { AlertColor } from "../../../utils/constants/Color.constants";

const CustomChip = ({ icon, label, hexColor }) => (
  <Chip
    icon={icon}
    label={label}
    variant="outlined"
    sx={{
      color: "white",
      borderColor: hexColor,
      backgroundColor: hexColor,
      fontWeight: "bold",
    }}
  />
);

const PendingChip = () => (
  <CustomChip
    icon={<Pending style={{ color: "white" }} />}
    label={"Pending"}
    hexColor={AlertColor.pending}
  />
);

const AcceptedChip = () => (
  <CustomChip
    icon={<Check style={{ color: "white" }} />}
    label={"Disetujui"}
    hexColor={AlertColor.success}
  />
);

const RejectedChip = () => (
  <CustomChip
    icon={<Cancel style={{ color: "white" }} />}
    label="Ditolak"
    hexColor={AlertColor.fail}
  />
);

const PendingRevisiMahasiswaChip = ({ hexColor }) => (
  <CustomChip
    icon={<Pending style={{ color: "white" }} />}
    label="Menunggu Revisi Mahasiswa"
    hexColor={hexColor || AlertColor.pendingYellow}
  />
);

const PendingPersetujuanDosenChip = ({ hexColor }) => (
  <CustomChip
    icon={<Pending style={{ color: "white" }} />}
    label="Menunggu Evaluasi Dosen"
    hexColor={hexColor || AlertColor.pendingYellow}
  />
);

export {
  CustomChip,
  PendingChip,
  AcceptedChip,
  RejectedChip,
  PendingRevisiMahasiswaChip,
  PendingPersetujuanDosenChip,
};
